import { useEffect } from 'react';

import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import {
  SENTRY_COMPONENT_PERFORMANCE_MONITORING_IS_ENABLED,
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,
  SENTRY_TRACES_SAMPLE_RATE,
} from '../config';
// @ts-ignore
import packageJson from '../../package.json';

export const isSentryEnabled = SENTRY_DSN?.startsWith('https://');
export const isComponentPerformanceMonitoringEnabled =
  isSentryEnabled && SENTRY_COMPONENT_PERFORMANCE_MONITORING_IS_ENABLED;

const tracesSampleRate =
  SENTRY_TRACES_SAMPLE_RATE >= 0 && SENTRY_TRACES_SAMPLE_RATE <= 1 ? SENTRY_TRACES_SAMPLE_RATE : 1;

if (isSentryEnabled) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    release: packageJson.version,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        maskAllText: false,
      }),
      Sentry.metrics.metricsAggregatorIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate,
    // Session Replay
    replaysSessionSampleRate: 0, // This sets the sample rate at 0%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}
